// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yGYM","title":"styles_title__-fRdJ"};